function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { Icon } from '@unite-us/ui';
import { formatPhoneNumber, getTelLink } from "./utils";
var PhoneNumberDisplay = /*#__PURE__*/function (_Component) {
  function PhoneNumberDisplay() {
    _classCallCheck(this, PhoneNumberDisplay);
    return _callSuper(this, PhoneNumberDisplay, arguments);
  }
  _inherits(PhoneNumberDisplay, _Component);
  return _createClass(PhoneNumberDisplay, [{
    key: "formattedPhoneLink",
    value: function formattedPhoneLink(phoneNumber) {
      var _this$props = this.props,
        primaryDisplayInline = _this$props.primaryDisplayInline,
        typeDisplayInline = _this$props.typeDisplayInline,
        iconStyle = _this$props.iconStyle;
      if (isEmpty(phoneNumber)) {
        return null;
      }
      var phoneNumberWithNoAreaCode = phoneNumber.phone_number.length === 7;
      var primaryDisplay = phoneNumber.is_primary && !this.props.hidePrimaryDisplay ? '(primary)' : null;
      var typeDisplay = /*#__PURE__*/React.createElement("span", null, phoneNumber.phone_type, " ", primaryDisplay);
      var formattedPhoneNumber = formatPhoneNumber(get(phoneNumber, 'phone_number'));
      var doNotDisplayLink = this.props.noLink || phoneNumberWithNoAreaCode;
      if (doNotDisplayLink) {
        return /*#__PURE__*/React.createElement("div", {
          className: "phone-number-display",
          style: {
            marginTop: '3px'
          }
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          icon: "IconPhone",
          style: iconStyle
        })), /*#__PURE__*/React.createElement("span", null, formattedPhoneNumber), typeDisplay && typeDisplayInline ? /*#__PURE__*/React.createElement("span", {
          className: "subhead"
        }, " ", typeDisplay) : null, primaryDisplay && primaryDisplayInline && !typeDisplayInline ? /*#__PURE__*/React.createElement("span", {
          className: "subhead"
        }, " ", primaryDisplay) : null);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "phone-number-display"
      }, this.props.shortDisplay ? null : /*#__PURE__*/React.createElement("p", {
        className: "subhead"
      }, typeDisplay), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
        href: getTelLink(phoneNumber)
      }, formattedPhoneNumber)));
    }
  }, {
    key: "render",
    value: function render() {
      var phoneNumber = this.props.item;
      if (isEmpty(phoneNumber)) {
        return null;
      }
      return this.formattedPhoneLink(phoneNumber);
    }
  }]);
}(Component);
PhoneNumberDisplay.propTypes = {
  item: PropTypes.object,
  iconStyle: PropTypes.object,
  shortDisplay: PropTypes.bool,
  hidePrimaryDisplay: PropTypes.bool,
  noLink: PropTypes.bool,
  primaryDisplayInline: PropTypes.bool,
  typeDisplayInline: PropTypes.bool
};
PhoneNumberDisplay.defaultProps = {
  iconStyle: {
    svg: {
      height: '12px',
      width: '12px'
    }
  },
  item: null,
  shortDisplay: false,
  hidePrimaryDisplay: false,
  noLink: false,
  primaryDisplayInline: false,
  typeDisplayInline: false
};
export default PhoneNumberDisplay;